import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { CreateChatBookmarkInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const CreateChatBookmarkMutation = graphql(`
  mutation CreateChatBookmark($input: CreateChatBookmarkInput!) {
    createChatBookmark(input: $input) {
      id
      __typename
      chatHistory {
        id
        __typename
        client {
          id
          __typename
          name
          externalReference
        }
        sessionId
        messages
        createdAt
        updatedAt
      }
      client {
        id
        __typename
        name
        externalReference
      }
      messageIndex
      title
      subtitle
      userDetailsId
      createdAt
    }
  }
`);

export function useCreateChatBookmark() {
  const [result, createChatBookmarkMutation] = useMutation(CreateChatBookmarkMutation);
  const [error, setError] = useState<Error | null>(null);

  const createChatBookmark = useCallback(
    async (input: CreateChatBookmarkInput) => {
      try {
        const response = await createChatBookmarkMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.createChatBookmark;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [createChatBookmarkMutation],
  );

  return { createChatBookmark, result, error };
}
